import { assertNever } from "@@/shared/assert-never";
import {
    isNotNaNOrNullOrUndefined,
    isNullOrUndefined,
} from "@@/utilities/null-checks";
import { setWithinPercentageRange } from "@@/utilities/set-within-range";
import { colorFactory } from "../color-factory";
import { cssStringToColor } from "../css-string-to-color";
import type { ColorItem } from "./color-item";

/**
 * @deprecated use .asString instead
 *
 * @param {(ColorItem | undefined)} color
 * @param {number} [alpha]
 * @return {*}  {string}
 */
const colorAsString = (
    color: ColorItem | undefined,
    alpha?: number,
): string => {
    if (isNullOrUndefined(color)) {
        return colorFactory({ hue: 360, saturation: 0.85, light: 0.55 }).value
            .asCssHsla;
    }
    const newAlpha = setWithinPercentageRange(alpha);
    if (typeof color === "string") {
        return isNotNaNOrNullOrUndefined(newAlpha)
            ? cssStringToColor(color).value.withAlpha(newAlpha).asString
            : color;
    }
    switch (color._type) {
        case "COLOR":
            return isNotNaNOrNullOrUndefined(newAlpha)
                ? color.value.withAlpha(newAlpha).asCssHsla
                : color.value.asCssHsla;
        case "COLOR_SET":
            return isNotNaNOrNullOrUndefined(newAlpha)
                ? color.main.value.withAlpha(newAlpha).asCssHsla
                : color.main.value.asCssHsla;
        case "COLOR_STRING":
            return isNotNaNOrNullOrUndefined(newAlpha)
                ? cssStringToColor(color.asString).value.withAlpha(newAlpha)
                      .asString
                : color.asString;
        case "COLOR_VALUE":
            return isNotNaNOrNullOrUndefined(newAlpha)
                ? color.withAlpha(newAlpha).asCssHsla
                : color.asCssHsla;
        default:
            assertNever(color);
    }
};

export { colorAsString };
